var map = {
	"./Banner_image_CSI_DH.jpg": 142,
	"./Banner_image_CSI_DH_small.jpg": 143,
	"./Banner_image_Delft.jpg": 144,
	"./Banner_image_Delft_small.jpg": 145,
	"./Banner_image_Kaapse.jpg": 146,
	"./Banner_image_Kaapse_small.jpg": 147,
	"./Banner_image_Philosophers_stone.jpg": 148,
	"./Banner_image_Philosophers_stone_small.jpg": 149,
	"./Banner_image_Ruimte.jpg": 150,
	"./Banner_image_Ruimte_small.jpg": 151,
	"./Banner_image_Werfkelder.jpg": 152,
	"./Banner_image_Werfkelder_small.jpg": 153,
	"./Banner_image_prison_break.jpg": 154,
	"./Banner_image_prison_break_small.jpg": 155,
	"./delftbanner.jpg": 156,
	"./kaapsebanner.jpg": 157,
	"./minibanner.jpg": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;